import StoredLayout from 'layouts/StoredLayout';
import React from 'react';
import { Container } from 'reactstrap';

// SGBC custom components
import PaymentPanel from './components/PaymentPanel';

class EventPaymentPage extends React.Component {
    // constructor(props) {
    //     super(props);
    // }
    render() {
        return (
            <Container>
                <PaymentPanel {...this.props} />
            </Container>
        );
    }
}

export default StoredLayout(EventPaymentPage);
